<template>
  <v-dialog
      v-model="contextModal"
      max-width="540"
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <h2 class="text-center">
              {{ contextEmployee.chosenName }}
            </h2>
          </v-col>
          <v-col cols="12">
            <h3 class="text-center">Выберите действие:</h3>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-col cols="12" class="text-center">
          <button
              v-if="!contextEmployee.away"
              type="button"
              class="btn btn-primary"
              @click="getAwayFromShift({
                            type: contextEmployee.chosenType,
                            id: contextEmployee.chosenId
                        })"
              :class="{ disabled: contextEmployee.chosenType == 'assistant' }"
          >
            Отошёл
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary"
            @click="returnToShift({
                            type: contextEmployee.chosenType,
                            id: contextEmployee.chosenId
                        })"
            :class="{
                        disabled: contextEmployee.chosenType == 'assistant'
                    }"
        >
          Вернулся
        </button>
        </v-col>
        <v-col
            v-if="workersWork.length > 1"
            cols="12"
            class="text-center"
        >
          <button
              v-if="!(Number(moneyboxAmount) > 0)"
              type="button"
              class="btn btn-primary"
              @click="leaveShift({
                            type: contextEmployee.chosenType,
                            id: contextEmployee.chosenId
                        })"
          >
            Выйти из смены
          </button>
          <v-tooltip
              v-else
              bottom
              color="black"
          >
            <template v-slot:activator="{ on, attrs }">
            <span
                v-bind="attrs"
                v-on="on"
            >
              <button
                  type="button"
                  class="btn btn-primary disabled mb-6"
                  @click="leaveShift({
                            type: contextEmployee.chosenType,
                            id: contextEmployee.chosenId
                        })"
              >
                Выйти из смены
              </button>
            </span>
            </template>
            <span>
            В копилке есть деньги - выводить мастера через копилку
            <br>
            Если этому мастеру не полагается копилка, то ему можно поставить 0₽ и вывести без копилки
          </span>
          </v-tooltip>
          <button
              v-if="!(Number(moneyboxAmount) === 0)"
              type="button"
              class="btn btn-primary"
              @click="showMoneyboxToEmployeeChargeModal({
                            type: contextEmployee.chosenType,
                            id: contextEmployee.chosenId,
                            name: contextEmployee.chosenName
                        })"
              :class="{ disabled: !moneyboxAmount }"
          >
            Распределить копилку и выйти
          </button>
        </v-col>
        <v-col cols="12" class="text-center">
          <button type="button" class="btn-cancel" @click="closeModal">
            Отмена
          </button>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "../../plugins/axios-common";
import { mapGetters } from "vuex";

export default {
  name: "contextModal",
  computed: {
    ...mapGetters('shift', ["shiftInfo", "contextEmployee"]),
    contextModal: {
      get() {
        return this.$store.state.shift.contextModal
      },
      set(newVal) {
        this.$store.dispatch('shift/setContextModal', newVal)
      },
    },
    workersWork() {
      return this.shiftInfo.workers ? this.shiftInfo.workers.filter(x => !x.leaved_at) : [];
    },
    moneybox() {
      return this.shiftInfo.moneybox ? this.shiftInfo.moneybox : [];
    },
    moneyboxAmount() {
      if (this.moneybox.total_sum - this.moneyboxCharge >= 0) {
        return this.moneybox.total_sum - this.moneyboxCharge;
      } else {
        return this.moneybox.total_sum;
      }
    },
    error () {
      return this.moneybox && this.moneyboxCharge ? this.moneybox.total_sum - this.moneyboxCharge >= 0 : false
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch('shift/setContextModal', false)
    },
    showMoneyboxToEmployeeChargeModal(payload) {
      this.closeModal();
      this.$store.commit("shift/updateMoneyboxEmployee", payload);
      if (
          (this.shiftInfo && this.shiftInfo.moneybox.status) ||
          (this.shiftInfo && this.shiftInfo.moneybox.total_sum > 0)
      ) {
        if (
            !(
                this.shiftInfo.basic.shiftMasterId === payload.id &&
                payload.type === "master"
            )
        ) {
          this.$store.commit("shift/updateMoneyboxEmployee", payload);
          this.$modal.show("moneyboxToEmployeeChargeModal");
        }
      }
    },
    leaveShift(payload) {
      this.closeModal();
      axios
          .post(
              `api/cash/shift/${this.shiftInfo.basic.number}/leave`,
              payload
          )
          .then(() => {
            location.reload();
          });

    },
    returnToShift(payload) {
      this.closeModal();
      axios
          .post(
              `api/cash/shift/${this.shiftInfo.basic.number}/checkin`,
              payload
          )
          .then(() => {
            location.reload();
          });
    },
    getAwayFromShift(payload) {
      this.closeModal();
      axios
          .post(
              `api/cash/shift/${this.shiftInfo.basic.number}/checkout`,
              payload
          )
          .then(() => {
            location.reload();
          });
    }
  }
};
</script>
<style scoped>
.btn {
  padding: 10px 30px;
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #000;
}

.btn-cancel {
  padding: 10px 30px;
  background: linear-gradient(180deg, #cbcec9 0%, #cfd1cc 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #000;
}
</style>
